import { Navigate } from 'react-router-dom'

import { useFetchContextDefaultEntityBackgroundByIdQuery } from '@redux/api'

import { getLocalStorageContext, getOptionRoute } from '@helpers'
import { ROUTES } from '@constants'

export const SwitchRouter = () => {
  const context = getLocalStorageContext()

  const { data: defaultEntities, isFetching: isFetchingDefaultEntities } =
    useFetchContextDefaultEntityBackgroundByIdQuery(context?.id, {
      skip: !context,
    })

  if (context === null) {
    return <Navigate replace to={ROUTES.CHOOSE_CONTEXT} />
  }

  if (isFetchingDefaultEntities) {
    return <Navigate replace to={ROUTES.DEFAULT_PAGE} />
  }

  if (defaultEntities?.length === 1) {
    return (
      <Navigate
        replace
        to={getOptionRoute({
          id: defaultEntities[0].sourceId as number,
          title: defaultEntities[0].title as string,
        })}
      />
    )
  }

  if (defaultEntities?.length === 2) {
    return (
      <Navigate
        replace
        to={getOptionRoute(
          {
            id: defaultEntities[0].sourceId as number,
            title: defaultEntities[0].title as string,
          },
          {
            id: defaultEntities[1].sourceId as number,
            title: defaultEntities[1].title as string,
          }
        )}
      />
    )
  }

  return <Navigate replace to={ROUTES.DEFAULT_PAGE} />
}
